/**
 * Check if a Formik errors object contains any actual error messages (strings).
 * Handles nested objects, arrays, and primitive string errors.
 *
 * @param {*} obj - A Formik errors object (or nested portion thereof)
 * @returns {boolean} true if any string error message exists in the structure
 */
export const hasErrorMessages = (obj) => {
  if (typeof obj === 'string') {
    return true;
  }
  if (Array.isArray(obj)) {
    return obj.some(hasErrorMessages);
  }
  if (obj && typeof obj === 'object') {
    return Object.values(obj).some(hasErrorMessages);
  }
  return false;
};
